( function () {
    'use strict';
    e.ecom.lazyload = {};
    e.ecom.lazyload = {
        lazyload: {
            options: {
                listElements: '.e-ecom-grid ul',
                loaderTpl: ''
            },
            data: {
                pages: {},
                allPages: 0,
            },
            loading: false,
            current: 1,
            cache: {},
            check: function () {
                var jThis = this;
                if ( jQuery( '#js-lazyload-paging-data' ).length ) {
                    jThis.data.pages = eval( JSON.parse( jQuery( '#js-lazyload-paging-data' ).html() ) );
                    jThis.data.allPages = jThis.data.pages.length;
                    jThis.options.loaderTpl = jQuery( '.js-lazyload-spinner-template' ).html();
                    jQuery( window ).on( 'scroll', function () {
                        if ( !jThis.loading && e.util.isInViewport( jQuery( jThis.options.listElements ).find( 'li' ).last() ) && jThis.allPages !== jThis.current ) {
                            jThis.fetchProducts();
                        }
                    } );
                }
            },
            loader: function ( show ) {
                this.loading = show;
                if ( show ) {
                    jQuery( this.options.listElements ).find( 'li' ).last().after( this.options.loaderTpl );
                }
                else {
                    jQuery( '.js-lazy-product-loader' ).slideUp( 'fast', function () {
                        jQuery( this ).remove();
                    } );
                }
            },
            fetchProducts: function () {
                if ( this.data.pages[ this.current ] !== undefined ) {
                    var jThis = this,
                        jData = this.data.pages,
                        nextDataUrl = jData[ this.current ].Url;
                    jThis.current++;
                    jQuery.ajax( {
                        url: nextDataUrl,
                        type: 'GET',
                        beforeSend: function () {
                            jThis.loader( true );
                        }
                    } ).done( function ( html ) {
                        var nextProducts = jQuery( html ).find( jThis.options.listElements ).html();
                        jThis.handleFetchedProducts( nextProducts );
                        jThis.saveState( nextProducts );
                    } ).fail( function ( data ) {
                        console.error( 'ERROR - ' + data );
                    } ).always( function () {
                        jThis.loader( false );
                    } );
                }
                else {
                    jQuery( window ).off( 'scroll' );
                }
            },
            handleFetchedProducts: function ( nextProducts ) {
                var jThis = this;
                jQuery.each( jQuery( nextProducts ), function ( index ) {
                    if ( jQuery( this ).is( 'li' ) ) {
                        if ( index === 0 ) {
                            jQuery( this ).addClass( 'pager' + jThis.current );
                        }
                        jQuery( jThis.options.listElements ).append( jQuery( this ) );
                    }
                } );
            },
            saveState: function ( jData ) {
                this.cache[ this.current ] = JSON.stringify( jData );
                history.pushState( this.cache, null, location.pathname + ( location.search.indexOf( 'pager' ) > -1 ? location.search.replace( 'pager=' + ( this.current - 1 ), 'pager=' + this.current ) : location.search.indexOf( '?' ) > -1 ? location.search + '&pager=' + this.current : location.search + '?pager=' + this.current ) );
            },
            handleHash: function () {
                var jThis = this;
                if ( location.hash ) {
                    window.scrollTo( 0, 0 );
                    e.util.scroll.toElement( jQuery( 'a[name="' + location.hash.replace( '#', '' ) + '"]' ), 44 );
                }
                e.constant.jWindow.on( 'beforeunload', function () {
                    history.pushState( this.cache, null, location.pathname + ( location.search.indexOf( 'pager' ) > -1 ? location.search.replace( 'pager=' + ( jThis.current - 1 ), 'pager=' + jThis.current ) : location.search.indexOf( '?' ) > -1 ? location.search + '&pager=' + jThis.current : location.search + '?pager=' + jThis.current ) );
                } );
            },
            loadCachedProductes: function () {
                var jThis = this,
                    historyArr = history.state;
                if ( historyArr !== null ) {
                    jQuery.each( historyArr, function ( index, val ) {
                        var jPageData = JSON.parse( val );
                        jThis.current = index;
                        jThis.cache[ index ] = val;
                        jThis.handleFetchedProducts( jPageData );
                    } );
                    this.handleHash();
                }
                this.check();
            },
            init: function () {
                this.loadCachedProductes();
            }
        },
        init: function () {
            this.lazyload.init();
        }
    };
}() );
